import { render } from "./ToolFooter.vue?vue&type=template&id=c5e3029a"
import script from "./ToolFooter.vue?vue&type=script&lang=js"
export * from "./ToolFooter.vue?vue&type=script&lang=js"

import "./ToolFooter.vue?vue&type=style&index=0&id=c5e3029a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__